import axios from 'axios';

export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const authConfig = () => ({ headers: getAuthHeaders() });

export const getTransactions = async () => {
  const response = await axios.get('/api/transactions/all', authConfig());
  return response.data;
};

export const getTransactionsSymbol = async (symbol) => {
  const response = await axios.get(`/api/transactions/symbol/${symbol}`, authConfig());
  return response.data;
};

export const createTransaction = async (transaction) => {
  const { user_id, userId, ...payload } = transaction;
  const response = await axios.post('/api/transactions', payload, authConfig());
  return response.data;
};

export const updateTransaction = async (id, transaction) => {
  const { user_id, userId, ...payload } = transaction;
  const response = await axios.put(`/api/transactions/${id}`, payload, authConfig());
  return response.data;
};

export const deleteTransaction = async (id) => {
  const response = await axios.delete(`/api/transactions/${id}`, authConfig());
  return response.data;
};

export const getAllTransactions = async () => {
  const response = await axios.get('/api/transactions/all', authConfig());
  return response.data;
};
